import { useEffect, useState } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow, { tableRowClasses } from '@mui/material/TableRow';
import React from 'react';
import { wrap } from "module";
import { useLanguage } from '@/app/utils/LanguageContext';
import { useMyContext } from '@/app/utils/MyContext';
import { getPastWinners } from '@/app/utils/request/requestList';
import { generateAdobeDataRaceNo, theme } from "@/app/utils/Common";
import ReplayIcon from "@/app/ui/Common/SvgComponent/ReplayIcon";
import { useMediaQuery } from "@mui/material";
import VideoPlayer from "@/app/ui/Common/VideoPlayer";
import { ValidVideo, VideoSource } from "@/app/utils/class/common/video";
import { generateVideoUrl, generateVideoSource, validateVideo } from "@/app/utils/Video";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";

interface propType {
  setRacesDetailLoading?: (loading: boolean) => void;
  type?: string;
}

interface Data {
  year: string;
  horse: string;
  jockey: string;
  trainer: string;
  replay: string;
}
function createData(
  year: string,
  horse: string,
  jockey: string,
  trainer: string,
  replay: string,
): Data {
  return {
    year,
    horse,
    jockey,
    trainer,
    replay
  }
}

const rows = [
  createData("2022", "GOLD TRIP", "Mark Zahra", "Ciaron Maher & David Eustace", ""),
  createData("2021", "VERRY ELLEEGANT", "James McDonald", "Chris Waller", ""),
  createData("2020", "TWILIGHT PAYMENT", "Jye McNeil", "Joseph O'Brien", ""),
  createData("2019", "VOW AND DECLARE", "Craig Williams", "Danny O'Brien", ""),
  createData("2018", "CROSS COUNTER", "Kerrin McEvoy", "Charlie Appleby", ""),
]

const TableHeader = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    color: "#FFFFFF",
    backgroundColor: "#6176A0",
    fontWeight: 400,
    padding: "8px 12px",
    ...textSize(13),
    textAlign: "left",
    height: "36px",
    lineHeight: "16px",
  }
}));

const StyledTableCell = styled(TableCell)<{ iscenter?: string }>(({ iscenter }) => ({
  [`&.${tableCellClasses.root}`]: {
    color: "#333333",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E1E1E1",
    fontWeight: 400,
    padding: "8px 0px 8px 8px",
    ...textSize(11),
    textAlign: iscenter == "true" ? "center" : "left",
    height: "32px",
    lineHeight: "14px",
    borderBottom: "0px",
  },
  [`&.${tableCellClasses.head}:last-child`]: {
    paddingRight: "8px",
  },
  [`&.${tableCellClasses.body}`]: {
    ...textSize(13),
    fontWeight: 500,
    padding: "8px",
    verticalAlign: "baseline",
    textAlign: iscenter == "true" ? "center" : "left",
    height: "40px",
    lineHeight: "24px"
  },
}));

const StyledTableCellMobile = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    color: "#333333",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E1E1E1",
    fontWeight: 400,
    ...textSize(11),
    padding: "4px 0px 4px 8px",
    textAlign: "center",
    lineHeight: "14px"
  },
  [`&.${tableCellClasses.head}:last-child`]: {
    paddingRight: "8px",
  },
  [`&.${tableCellClasses.body}`]: {
    ...textSize(13),
    fontWeight: 500,
    verticalAlign: "baseline",
    padding: "8px 0px 8px 8px",
    textAlign: "center",
    lineHeight: "16px"
  },
}));


const ReplayCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    textAlign: "center",
    verticalAlign: "middle",
    padding: "8px !important",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(even)': {
    backgroundColor: "#F4F4F4",
  },
  '&:nth-of-type(odd)': {
    backgroundColor: "#FFFFFF",
  },
  'td, th': {
    border: 0,
  },
  'td:last-child, th:last-child': {
    paddingRight: "8px",
  },
  'td svg': {
    cursor: "pointer",
  }
}));

const HorseDetailsRowMobile = styled(TableRow)(() => ({
  [`&.${tableRowClasses.root}`]: {
    backgroundColor: "transparent",
  },
  'td: first-child': {
    width: "17%",
    whiteSpace: "nowrap",
    paddingRight: "8px",
  }
}));
const HorseDetailsCellMobile = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    ...textSize(11),
    padding: "0",
  }
}));

interface RacingInfoProps {
  meetings: IMeeting[];
  type: String;
  pageUrl?: string;
  pageId?: string;
  b_cid?: string;
}

const PastWinners: React.FC<RacingInfoProps> = (props: RacingInfoProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const { state: lang } = useLanguage();
  const { t: dict } = lang;
  const [pastWinner, setPastWinner] = useState([]);
  const [pastWinnerConfig, setPastWinnerConfig] = useState<any>({});
  const [pastWinnerVideosUrl, setPastWinnerVideosUrl] = useState([]);
  const [selectedWAData, setSelectedWAData] = useState<VideoWAData|undefined>(undefined);
  const [videoValidation, setVideoValidation] = useState([] as ValidVideo[]);
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const [isShowReplay, setIsShowReplay] = useState(false);
  const [replaySources, setReplaySources] = useState([] as VideoSource[]);

  useEffect(() => {
    if (!myContextState.selectedMeeting?.displayName || !myContextState.selectedRace?.displayName) {
      validatePastWinnerVideos(null, null);
      setPastWinner([]);
      setPastWinnerConfig([]);
      setSelectedWAData(undefined);
      return
    }
    getPastWinners(lang.langCode, myContextState.season, myContextState.selectedMeeting.displayName, myContextState.selectedRace.displayName)
      .then((res: any) => {
        validatePastWinnerVideos(res.data?.pastWinners, res.config)
        .then(()=>{
          setPastWinner(res.data?.pastWinners || []);
          setPastWinnerConfig(res.config);
        })
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, [myContextState.selectedMeeting, myContextState.selectedRace]);

  const validatePastWinnerVideos = async (data: any, config: any) => {
    if (!config || !data || data.length === 0) {
      setVideoValidation([]);
      setPastWinnerVideosUrl([]);
      return;
    };
    const videosUrls = data?.map((row: any)=>{
      if (row.replayVideo?.value && [...Array(5)].some((_, i)=> config?.[`enabled${i+1}`]?.value === "1" && config?.[`isVideo${i+1}`]?.value === "1")) {
          return generateVideoUrl(row.replayVideo?.value)
      }
      return null
    })
    const newVideoValidation = await Promise.all<ValidVideo[]>(videosUrls?.map(async (url: any)=>validateVideo(url)));
    setVideoValidation(newVideoValidation);
    setPastWinnerVideosUrl(videosUrls);
  }

  const openVideoPlayer = (idx: number, waContentTitle?: string) => {
    const {sd, hd} = pastWinnerVideosUrl[idx];
    setSelectedWAData({
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
      contentTitle: waContentTitle,
    });
    setReplaySources(generateVideoSource(sd, hd, videoValidation[idx]));
    setIsShowReplay(true);
  }

  const handleClose = () => {
    setIsShowReplay(false);
    setSelectedWAData(undefined);
    setReplaySources([]);
  }

  const renderReplayIcon = (idx: number, year?: string) => <ReplayCell>{videoValidation.length > idx && videoValidation[idx].hasVideo() && <ReplayIcon onClick={() => openVideoPlayer(idx, year)} />}</ReplayCell>

  const renderPcTable = () => {
    return (
      <TableContainer sx={{ display: "flex", padding: "10px 17px" }}>
        <Table id="PastWinner_Table_pc" sx={{ border: "var(--border)", borderCollapse: "separate", borderRadius: "4px", overflow: "hidden", textAlign: "left !important", boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableHeader id="PastWinner_Title_pc" colSpan={5}>{dict("pastWinner")}</TableHeader>
            </TableRow>
            <TableRow id="PastWinner_Header_pc">
              {pastWinnerConfig?.enabled1?.value === "1" ? (<StyledTableCell >{pastWinnerConfig?.label1?.value}</StyledTableCell>) : (<></>)}
              {pastWinnerConfig?.enabled2?.value === "1" ? (<StyledTableCell >{pastWinnerConfig?.label2?.value}</StyledTableCell>) : (<></>)}
              {pastWinnerConfig?.enabled3?.value === "1" ? (<StyledTableCell >{pastWinnerConfig?.label3?.value}</StyledTableCell>) : (<></>)}
              {pastWinnerConfig?.enabled4?.value === "1" ? (<StyledTableCell >{pastWinnerConfig?.label4?.value}</StyledTableCell>) : (<></>)}
              {pastWinnerConfig?.enabled5?.value === "1" ? (<StyledTableCell iscenter={"true"}>{pastWinnerConfig?.label5?.value}</StyledTableCell>) : (<></>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {pastWinner?.map((row: any, i: number) => (
              <StyledTableRow key={"PastWinner_Row_" + i} id={`PastWinner_Row_${row.year?.value}`}>
                {pastWinnerConfig?.enabled1?.value === "1" ? pastWinnerConfig?.isVideo1?.value === "1" ? (renderReplayIcon(i, row.year?.value)) : (<StyledTableCell >{row.year?.value}</StyledTableCell>) : (<></>)}
                {pastWinnerConfig?.enabled2?.value === "1" ? pastWinnerConfig?.isVideo2?.value === "1" ? (renderReplayIcon(i, row.year?.value)) : (<StyledTableCell sx={{ textAlign: "left !important" }}>{row.horse?.value}</StyledTableCell>) : (<></>)}
                {pastWinnerConfig?.enabled3?.value === "1" ? pastWinnerConfig?.isVideo3?.value === "1" ? (renderReplayIcon(i, row.year?.value)) : (<StyledTableCell >{row.jockey?.value}</StyledTableCell>) : (<></>)}
                {pastWinnerConfig?.enabled4?.value === "1" ? pastWinnerConfig?.isVideo4?.value === "1" ? (renderReplayIcon(i, row.year?.value)) : (<StyledTableCell >{row.trainer?.value}</StyledTableCell>) : (<></>)}
                {pastWinnerConfig?.enabled5?.value === "1" ? pastWinnerConfig?.isVideo5?.value === "1" ? (renderReplayIcon(i, row.year?.value)) : (<StyledTableCell >{row.replayVideo?.value}</StyledTableCell>) : (<></>)}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  };

  const renderMobileTable = () => {
    return (
      <TableContainer sx={{ display: "flex", marginTop: "2.37vw", boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)", border: "var(--border)", borderCollapse: "separate", borderRadius: "4px", overflow: "scroll" }}>
        <Table id="PastWinner_Table_mobile" aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableHeader id="PastWinner_Title_mobile" colSpan={5}>{dict("pastWinner")}</TableHeader>
            </TableRow>
            <TableRow id="PastWinner_Header_mobile">
              <StyledTableCellMobile sx={{ width: "12.5%" }}>{dict("year")}</StyledTableCellMobile>
              <StyledTableCellMobile sx={{ textAlign: "left !important" }}>{dict("horseDetails")}</StyledTableCellMobile>
              <StyledTableCellMobile sx={{ width: "12.5%" }}>{dict("replay")}</StyledTableCellMobile>
            </TableRow>
          </TableHead>
          <TableBody>
            {pastWinner?.map((row: any, i: number) => (
              <StyledTableRow key={"PastWinner_Row_" + i} id={`PastWinner_Row_${row.year?.value}`}>
                <StyledTableCellMobile>
                  {pastWinnerConfig?.enabled1?.value === "1" ? row.year.value : ""}
                </StyledTableCellMobile>
                <StyledTableCellMobile sx={{ textAlign: "left !important" }}>
                  {pastWinnerConfig?.enabled2?.value === "1" ? row.horse.value : ""}
                  <Table>
                    <TableBody>
                      {pastWinnerConfig?.enabled3?.value === "1" ? (
                        <HorseDetailsRowMobile>
                          <HorseDetailsCellMobile>{pastWinnerConfig?.label3?.value}</HorseDetailsCellMobile>
                          <HorseDetailsCellMobile>{row.jockey.value}</HorseDetailsCellMobile>
                        </HorseDetailsRowMobile>
                      ) : (<></>)}
                      {pastWinnerConfig?.enabled4?.value === "1" ? (
                        <HorseDetailsRowMobile>
                          <HorseDetailsCellMobile>{pastWinnerConfig?.label4?.value}</HorseDetailsCellMobile>
                          <HorseDetailsCellMobile>{row.trainer.value}</HorseDetailsCellMobile>
                        </HorseDetailsRowMobile>
                      ) : (<></>)}
                    </TableBody>
                  </Table>
                </StyledTableCellMobile>
                <>
                  {pastWinnerConfig?.enabled5?.value === "1" ? pastWinnerConfig?.isVideo5?.value === "1" ? renderReplayIcon(i, row.year?.value) : (<>{row.replayVideo.value}</>) : (<></>)}
                </>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  };

  return (
    <>
      {pastWinner.length > 0 && (props?.type === "pc" ? renderPcTable() : renderMobileTable())}
      <VideoPlayer WAData={selectedWAData} sources={replaySources} open={isShowReplay} isMobile={isMobile} handleClose={handleClose} width={isMobile?undefined:'60%'} height={isMobile?undefined:'60%'} showCurrentTooltip showHoveredTooltip autoPlay />
    </>
  );
};
export default PastWinners;
